/* Clippy homepage sections. Each section loads this file; the guard makes it run once. */
(function () {
  if (window.ClippyUI) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* Hero video respects reduced motion */
  function initHero(root) {
    root.querySelectorAll('[data-cl-hero-video]').forEach(function (v) {
      if (!once(v, 'clReady')) return;
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; }
    });
  }

  /* Board rolling down the road line as you scroll */
  var railBound = false;
  function initRail() {
    if (railBound) return;
    railBound = true;
    var ticking = false;
    function move() {
      var svg = document.querySelector('[data-cl-rail] svg');
      ticking = false;
      if (!svg) return;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      svg.style.transform = 'translateY(' + p * (window.innerHeight - 100) + 'px)';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(move); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', move);
    move();
  }

  /* Pop, clip, go diagram: plays once when it scrolls into view, then the buttons take over */
  function initDemo(root) {
    root.querySelectorAll('[data-cl-demo]').forEach(function (demo) {
      if (!once(demo, 'clReady')) return;
      var svg = demo.querySelector('svg');
      var cap = demo.querySelector('[data-cl-caption]');
      var buttons = demo.querySelectorAll('[data-step]');
      var play = demo.querySelector('[data-cl-play]');
      var timers = [];
      if (reduce && svg.pauseAnimations) svg.pauseAnimations();
      function stop() { timers.forEach(clearTimeout); timers = []; }
      function setStep(b) {
        svg.setAttribute('data-state', b.dataset.step);
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        cap.innerHTML = '';
        var strong = document.createElement('strong');
        strong.textContent = b.dataset.title;
        cap.appendChild(strong);
        cap.appendChild(document.createTextNode(b.dataset.text));
      }
      function runSequence() {
        stop();
        svg.setAttribute('data-state', 'ground');
        buttons.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        var gap = reduce ? 1600 : 1500;
        buttons.forEach(function (b, i) { timers.push(setTimeout(function () { setStep(b); }, 1700 + i * gap)); });
      }
      buttons.forEach(function (b) { b.addEventListener('click', function () { stop(); setStep(b); }); });
      if (play) play.addEventListener('click', runSequence);
      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); runSequence(); }
        }, { threshold: 0.6 });
        io.observe(svg);
      }
    });
  }

  /* Clip / tool / stand tabs */
  function initTabs(root) {
    root.querySelectorAll('[data-cl-tabs]').forEach(function (wrap) {
      if (!once(wrap, 'clReady')) return;
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role=tab]'));
      function show(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
            show(tabs[n], true);
          }
        });
      });
    });
  }

  /* Journey time calculator (miles and mph) */
  function initCommute(root) {
    root.querySelectorAll('[data-cl-commute]').forEach(function (c) {
      if (!once(c, 'clReady')) return;
      function q(name) { return c.querySelector('[data-cl="' + name + '"]'); }
      function calc() {
        var d = parseFloat(q('dist').value) || 0;
        var trips = parseFloat(q('trips').value) || 0;
        var w = Math.max(parseFloat(q('walk').value) || 3, 0.5);
        var s = Math.max(parseFloat(q('skate').value) || 7.5, 0.5);
        var wm = d / w * 60, sm = d / s * 60;
        var saved = Math.max(wm - sm, 0) * trips * 4.33 / 60;
        q('distOut').textContent = d + (d === 1 ? ' mile' : ' miles');
        q('tripsOut').textContent = trips;
        q('walkMin').textContent = Math.round(wm) + ' min';
        q('skateMin').textContent = Math.round(sm) + ' min';
        var top = Math.max(wm, sm) || 1;
        q('walkBar').style.width = (wm / top * 100) + '%';
        q('skateBar').style.width = (sm / top * 100) + '%';
        q('hours').textContent = saved >= 10 ? Math.round(saved) : saved.toFixed(1);
      }
      ['dist', 'trips', 'walk', 'skate'].forEach(function (n) { q(n).addEventListener('input', calc); });
      calc();
    });
  }

  /* Will it fit checker */
  function initFit(root) {
    root.querySelectorAll('[data-cl-fit]').forEach(function (f) {
      if (!once(f, 'clReady')) return;
      var out = f.querySelector('[data-cl-verdict]');
      f.querySelector('.cl-fit__qs').addEventListener('change', function () {
        function v(n) { var el = f.querySelector('input[name="' + n + '"]:checked'); return el ? el.value : null; }
        var h = v('cl-handle'), st = v('cl-strap'), tr = v('cl-trucks');
        var key = null;
        if (h === 'no') key = 'no';
        else if (h === 'unsure') key = 'unsure';
        else if (h && st && tr) key = st === 'padded' ? 'padded' : (tr === 'other' ? 'other' : 'good');
        if (!key) { out.hidden = true; return; }
        var tpl = f.querySelector('template[data-verdict="' + key + '"]');
        out.className = 'cl-verdict' + (key === 'good' ? ' cl-verdict--good' : '');
        out.innerHTML = '';
        out.appendChild(tpl.content.cloneNode(true));
        out.hidden = false;
      });
    });
  }

  /* 3D spinner: loads Google's model-viewer once, then wires up the view buttons, labels and toggles */
  var mvRequested = false;
  function loadModelViewer() {
    if (mvRequested || window.customElements.get('model-viewer')) return;
    mvRequested = true;
    var s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
    document.head.appendChild(s);
  }

  function initSpin(root) {
    root.querySelectorAll('[data-cl-spin]').forEach(function (sec) {
      if (!once(sec, 'clReady')) return;
      var mv = sec.querySelector('model-viewer');
      if (!mv) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); loadModelViewer(); }
        }, { rootMargin: '600px 0px' });
        io.observe(sec);
      } else {
        loadModelViewer();
      }

      var modes = Array.prototype.slice.call(sec.querySelectorAll('.cl-spin__mode'));
      var hots = Array.prototype.slice.call(sec.querySelectorAll('.cl-hot'));
      var labelsBtn = sec.querySelector('[data-cl-spin-labels]');
      var autoBtn = sec.querySelector('[data-cl-spin-auto]');
      var resetBtn = sec.querySelector('[data-cl-spin-reset]');
      var bar = sec.querySelector('.cl-spin__progress');
      var current = 0;

      if (reduce) {
        mv.removeAttribute('auto-rotate');
        if (autoBtn) autoBtn.setAttribute('aria-pressed', 'false');
      }
      if (labelsBtn && labelsBtn.getAttribute('aria-pressed') === 'true') sec.classList.add('is-labels');

      function resetView() {
        var orbit = modes[current] && modes[current].dataset.orbit;
        mv.cameraOrbit = orbit || 'auto auto auto';
        mv.cameraTarget = 'auto auto auto';
        mv.fieldOfView = 'auto';
        if (typeof mv.resetTurntableRotation === 'function') mv.resetTurntableRotation();
        if (typeof mv.jumpCameraToGoal === 'function') mv.jumpCameraToGoal();
      }

      function show(i) {
        var b = modes[i];
        if (!b) return;
        current = i;
        modes.forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
          var cap = document.getElementById(x.getAttribute('aria-controls'));
          if (cap) cap.hidden = x !== b;
        });
        hots.forEach(function (h) { h.hidden = h.dataset.mode !== String(i); h.classList.remove('is-open'); });
        if (b.dataset.src && mv.getAttribute('src') !== b.dataset.src) {
          if (b.dataset.poster) mv.setAttribute('poster', b.dataset.poster); else mv.removeAttribute('poster');
          if (b.dataset.ios) mv.setAttribute('ios-src', b.dataset.ios); else mv.removeAttribute('ios-src');
          mv.setAttribute('src', b.dataset.src);
          if (b.dataset.orbit) mv.setAttribute('camera-orbit', b.dataset.orbit); else mv.removeAttribute('camera-orbit');
        } else {
          resetView();
        }
      }

      modes.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });

      mv.addEventListener('load', function () { resetView(); });
      /* keep each label inside the frame: tags on the right half point left */
      var sideTick = false;
      function sideLabels() {
        sideTick = false;
        var r = mv.getBoundingClientRect();
        hots.forEach(function (h) {
          if (h.hidden) return;
          var d = h.getBoundingClientRect();
          h.classList.toggle('is-left', d.left + d.width / 2 > r.left + r.width * 0.55);
        });
      }
      mv.addEventListener('camera-change', function () {
        if (!sideTick) { sideTick = true; window.requestAnimationFrame(sideLabels); }
      });
      mv.addEventListener('progress', function (e) {
        if (!bar) return;
        var p = e.detail && e.detail.totalProgress || 0;
        bar.firstElementChild.style.width = (p * 100) + '%';
        bar.classList.toggle('is-done', p >= 1);
      });

      hots.forEach(function (h) {
        h.addEventListener('click', function () {
          var open = !h.classList.contains('is-open');
          hots.forEach(function (x) { x.classList.remove('is-open'); });
          h.classList.toggle('is-open', open);
        });
      });

      if (labelsBtn) labelsBtn.addEventListener('click', function () {
        var on = labelsBtn.getAttribute('aria-pressed') !== 'true';
        labelsBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        sec.classList.toggle('is-labels', on);
      });
      if (autoBtn) autoBtn.addEventListener('click', function () {
        var on = autoBtn.getAttribute('aria-pressed') !== 'true';
        autoBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { mv.setAttribute('auto-rotate', ''); mv.setAttribute('auto-rotate-delay', '0'); mv.setAttribute('rotation-per-second', '18deg'); }
        else mv.removeAttribute('auto-rotate');
      });
      if (resetBtn) resetBtn.addEventListener('click', resetView);
    });
  }

  /* Our Story road timeline: the board rolls to the year you pick */
  function initJourney(root) {
    root.querySelectorAll('[data-cl-journey]').forEach(function (sec) {
      if (!once(sec, 'clReady')) return;
      var stops = Array.prototype.slice.call(sec.querySelectorAll('.cl-jstop'));
      var prev = sec.querySelector('[data-cl-jprev]');
      var next = sec.querySelector('[data-cl-jnext]');
      var count = sec.querySelector('[data-cl-jcount]');
      var current = 0, rollTimer;
      function show(i, focus) {
        if (i < 0 || i >= stops.length) return;
        var b = stops[i];
        sec.classList.toggle('is-back', i < current);
        if (i !== current && !reduce) {
          sec.classList.add('is-rolling');
          clearTimeout(rollTimer);
          rollTimer = setTimeout(function () { sec.classList.remove('is-rolling'); }, 800);
        }
        current = i;
        sec.style.setProperty('--xn', (parseFloat(b.dataset.x) || 0) / 100);
        stops.forEach(function (s) {
          s.setAttribute('aria-pressed', s === b ? 'true' : 'false');
          var panel = document.getElementById(s.getAttribute('aria-controls'));
          if (panel) panel.hidden = s !== b;
        });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === stops.length - 1;
        if (count) count.textContent = (i + 1) + ' of ' + stops.length;
        if (focus) b.focus();
      }
      stops.forEach(function (b, i) {
        b.addEventListener('click', function () { show(i); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show(Math.min(i + 1, stops.length - 1), true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(Math.max(i - 1, 0), true); }
        });
      });
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      show(0);
    });
  }

  /* Our Story build sheet: spec lines light up their part on the drawing */
  function initBuild(root) {
    root.querySelectorAll('[data-cl-build]').forEach(function (sec) {
      if (!once(sec, 'clReady')) return;
      var svg = sec.querySelector('svg[data-hl]');
      var rows = Array.prototype.slice.call(sec.querySelectorAll('tr[data-hl]'));
      var pinned = null;
      function light(part) { svg.setAttribute('data-hl', part || 'none'); }
      rows.forEach(function (r) {
        var part = r.dataset.hl;
        if (part === 'none') return;
        r.addEventListener('mouseenter', function () { light(part); });
        r.addEventListener('mouseleave', function () { light(pinned ? pinned.dataset.hl : 'none'); });
        r.addEventListener('focus', function () { light(part); });
        r.addEventListener('blur', function () { light(pinned ? pinned.dataset.hl : 'none'); });
        r.addEventListener('click', function () {
          if (pinned) pinned.classList.remove('is-on');
          pinned = pinned === r ? null : r;
          if (pinned) pinned.classList.add('is-on');
          light(pinned ? part : 'none');
        });
        r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); r.click(); } });
      });
    });
  }

  /* Header: phone menu */
  function initHead(root) {
    root.querySelectorAll('[data-cl-head]').forEach(function (h) {
      if (!once(h, 'clReady')) return;
      var btn = h.querySelector('[data-cl-burger]');
      var menu = btn && document.getElementById(btn.getAttribute('aria-controls'));
      if (!btn || !menu) return;
      function set(open) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }
      btn.addEventListener('click', function () { set(menu.hidden); });
      menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
    });
  }

  /* Product page: gallery, quantity, variants and the phone buy bar */
  function initPdp(root) {
    root.querySelectorAll('[data-cl-pdp]').forEach(function (sec) {
      if (!once(sec, 'clReady')) return;

      var slides = Array.prototype.slice.call(sec.querySelectorAll('.cl-gallery__slide'));
      var thumbs = Array.prototype.slice.call(sec.querySelectorAll('.cl-gallery__thumb'));
      var cur = 0;
      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== cur; });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
        if (thumbs[cur] && thumbs[cur].scrollIntoView) thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var pv = sec.querySelector('[data-cl-gal-prev]'), nx = sec.querySelector('[data-cl-gal-next]');
      if (pv) pv.addEventListener('click', function () { go(cur - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1); });
      var main = sec.querySelector('.cl-gallery__main'), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
        });
      }

      var qty = sec.querySelector('input[name="quantity"]');
      sec.querySelectorAll('[data-cl-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var max = parseInt(qty.max, 10) || 10;
          qty.value = Math.min(max, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.clQty, 10)));
        });
      });

      var idInput = sec.querySelector('[data-cl-variant-id]');
      var prices = sec.querySelectorAll('[data-cl-price]');
      sec.querySelectorAll('input[name="cl-variant"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (idInput) idInput.value = r.value;
          prices.forEach(function (p) { p.textContent = r.dataset.price; });
        });
      });

      var bar = sec.querySelector('[data-cl-sticky]');
      var add = sec.querySelector('.cl-buy__add');
      if (bar && add && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
        }).observe(add);
      }
    });
  }

  /* Our Story: street section, prototype cards, then-and-now slider */
  function initStreet(root) {
    root.querySelectorAll('[data-cl-street]').forEach(function (sec) {
      if (!once(sec, 'clReady')) return;
      var svg = sec.querySelector('svg[data-zone]');
      var btns = Array.prototype.slice.call(sec.querySelectorAll('.cl-street__btns button'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          svg.setAttribute('data-zone', b.dataset.zone);
          btns.forEach(function (x) {
            x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
            var c = document.getElementById(x.getAttribute('aria-controls'));
            if (c) c.hidden = x !== b;
          });
        });
      });
    });
  }
  function initProtos(root) {
    root.querySelectorAll('[data-cl-protos] .cl-proto').forEach(function (c) {
      if (!once(c, 'clReady')) return;
      c.addEventListener('click', function () { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); });
    });
  }
  function initThenNow(root) {
    root.querySelectorAll('[data-cl-tn]').forEach(function (sec) {
      if (!once(sec, 'clReady')) return;
      var frame = sec.querySelector('.cl-tn__frame'), r = sec.querySelector('.cl-tn__range');
      if (!frame || !r) return;
      r.addEventListener('input', function () { frame.style.setProperty('--cut', r.value + '%'); });
    });
  }

  /* 404: tap the board to flip it back over */
  function init404(root) {
    root.querySelectorAll('[data-cl-404] .cl-404__board').forEach(function (b) {
      if (!once(b, 'clReady')) return;
      function flip() { b.classList.toggle('is-up'); }
      b.addEventListener('click', flip);
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
    });
  }

  /* Tap-to-play community clips (Shopify streams these as HLS) */
  function initClips(root) {
    root.querySelectorAll('[data-cl-clip]').forEach(function (btn) {
      if (!once(btn, 'clReady')) return;
      btn.addEventListener('click', function () {
        var v = document.createElement('video');
        v.controls = true;
        v.playsInline = true;
        var src = btn.dataset.src;
        if (v.canPlayType('application/vnd.apple.mpegurl')) v.src = src;
        else if (window.Hls && window.Hls.isSupported()) { var hls = new window.Hls(); hls.loadSource(src); hls.attachMedia(v); }
        else if (btn.dataset.fallback) { window.location.href = btn.dataset.fallback; return; }
        btn.replaceWith(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }

  /* Drop 02 signup: turns the extra answers into customer tags */
  function initDrop(root) {
    root.querySelectorAll('[data-cl-drop]').forEach(function (card) {
      var form = card.querySelector('form');
      if (!form || !once(card, 'clReady')) return;
      form.addEventListener('submit', function () {
        var tagInput = form.querySelector('[data-cl-tags]');
        if (!tagInput) return;
        var tags = (card.dataset.baseTags || 'newsletter').split(',');
        var ride = form.querySelector('input[name="cl-ride"]:checked');
        var city = form.querySelector('[data-cl-city]');
        if (ride) tags.push('rides-' + ride.value);
        var ask = form.querySelector('input[name="cl-ask"]:checked');
        if (ask) tags.push('drop02-' + ask.value);
        if (city && city.value.trim()) tags.push('city-' + city.value.trim().replace(/,/g, ' ').slice(0, 40));
        tagInput.value = tags.join(',');
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initHero(root); initDemo(root); initTabs(root); initCommute(root);
    initFit(root); initClips(root); initDrop(root); initSpin(root); initJourney(root); initBuild(root); initHead(root); initPdp(root); initStreet(root); initProtos(root); initThenNow(root); init404(root);
    if (document.querySelector('[data-cl-rail]')) initRail();
  }

  window.ClippyUI = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* Re-run when a section is added or edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
